// QA testing environment
// Secrets are injected via CI/CD pipeline

export const environment = {
  production: false,
  messages: {
    console: true,
    alert: true,
    confirm: false,
    notify: false,
    error: false,
    track: false,
    debug_messages: false,
    debug: true,
  },
  api: {
    url: 'https://qa.hotelcard.com/api',
    mock: false,
    enableMocks: false,
    hotel_images: 'https://hotelcard-stage.fra1.digitaloceanspaces.com/',
    customer_redirect_to: 'https://qa.hotelcard.com',
    oauth: {
      grant_type: 'password',
      client_id: '14',
      client_secret: '82451a2f4313270dc424fffdfd7a259445d1f00f865de8cc10fff2324c7edf96',
    },
  },
  // Google Maps API key - injected at build time
  googleMapsApiKey: '__GOOGLE_MAPS_API_KEY__',
  translations: {
    whitelist: ['en', 'de', 'it', 'fr'],
    fallbackLng: 'de',
    debug: true,
    returnEmptyString: false,
    ns: ['translations', 'errors', 'titles'],
    initImmediate: false,
    backend: {
      loadPath: function () {
        return 'assets/i18n/{{ns}}/{{lng}}.json?date=' + new Date().getTime();
      }
    },
    detection: {
      order: ['querystring', 'cookie', 'navigator', 'hotelCardLangDetector'],
      lookupCookie: 'lang',
      caches: ['cookie'],
      cookieMinutes: 10080, // 7 days
      lookupQuerystring: 'locale',
    },
    keySeparator: '.',
    fallbackNS: 'translations',
  },
};
